module.exports = __webpack_public_path__ + "img/arrow-link.b68a8538.svg";